import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-5 mb-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("h1", { class: "" }, "Components"),
  /*#__PURE__*/_createVNode("p", { class: "lead" }, " Components are the reusable building blocks of our design system. Each component meets a specific interaction or UI need, and has been specifically created to work together to create patterns and intuitive user experiences. "),
  /*#__PURE__*/_createVNode("div", { class: "alert alert-warning mt-4" }, " To access the repositories and documentation, you need to have access to the Github Tradesolution account. Reach out to Julie with your Github username/email. ")
], -1)
const _hoisted_3 = { class: "row mt-3" }
const _hoisted_4 = { class: "col mt-3 text-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col mt-3 text-center\"><div class=\"widget has-content\"><header class=\"widget-header\"><span class=\"header-text\">React Components</span></header><main class=\"widget-body\"><div class=\"col\"><code class=\"mt-3\"> npm install @tradesolution/iceberg-ui-react </code></div><a href=\"https://github.com/Tradesolution/iceberg-ui-react/\" class=\"btn btn-primary mt-4\"> Check out the repo 🚀 </a><a href=\"https://master--60a77b8cca12bc0039e80030.chromatic.com\" class=\"btn btn-primary mt-4 ms-4\">Documentation 📚</a></main></div></div>", 1)
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"col-6 mt-3 text-center\"><div class=\"widget has-content\"><header class=\"widget-header\"><span class=\"header-text\">Migrate from AngularJS to Angular</span></header><main class=\"widget-body\"><p> If your app currently uses AngularJS... we feel sorry for you! <br> Reach out to Julie, and ask about a possible migration process! <br></p></main></div></div>", 1)
const _hoisted_8 = { class: "col-6 mt-3 text-center" }
const _hoisted_9 = { class: "widget has-content" }
const _hoisted_10 = /*#__PURE__*/_createVNode("header", { class: "widget-header" }, [
  /*#__PURE__*/_createVNode("span", { class: "header-text" }, "Integrations")
], -1)
const _hoisted_11 = { class: "widget-body" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" For documentation regarding our integrations, ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" such as ")
const _hoisted_15 = /*#__PURE__*/_createVNode("b", null, "Beamer", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(", see ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Integrations")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WidgetAngularLibrary = _resolveComponent("WidgetAngularLibrary")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_WidgetAngularLibrary)
      ]),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("main", _hoisted_11, [
            _createVNode("p", null, [
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _createVNode(_component_router_link, {
                class: "",
                to: "integrations"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _hoisted_18
            ])
          ])
        ])
      ])
    ])
  ]))
}